import React, { useState, useEffect } from "react";
import axios from "axios";
import * as cheerio from "cheerio";
import { AES } from "crypto-js";
require("dotenv").config();

function App() {
  const [page, setPage] = useState(1);
  const [error, setError] = useState(false);
  const [finalData, setFinalData] = useState([]);
  useEffect(() => {
    getData();
  }, [page]);

  async function getData() {
    const sendIt = {
      userName: process.env.REACT_APP_USERNAME,
      password: process.env.REACT_APP_PASSWORD,
    };
    const ciperText = AES.encrypt(
      JSON.stringify(sendIt),
      process.env.REACT_APP_SECRET_KEY
    ).toString();

    await axios
      .post(`https://fast-sands-75899.herokuapp.com/getData?page=${page}`, {
        timeout: 10000,
        data: {
          ciperText,
        },
      })
      .then((response) => {
        const $ = cheerio.load(response.data);
        const productLink = $(".a-link-normal");
        const todayPrice = $(".a-price");
        const productName =
          page === 1
            ? $(".a-text-normal", ".a-link-normal")
                .toArray()
                .map((x) => {
                  return $(x).text();
                })
            : $(".a-size-medium")
                .toArray()
                .map((x) => {
                  return $(x).text();
                });
        setError(false);
        returnFinalArray(productLink, todayPrice, productName);
      })
      .catch((err) => {
        console.log("Error is ", err);
        setError(err);
      });
  }

  function returnFinalArray(productLink, todayPrice, productName) {
    const productLinkArrayConst = [];
    const productImageLinkConst = [];
    const todayPriceConst = [];
    const originalPriceConst = [];
    if (
      productLink.length > 0 &&
      todayPrice.length > 0 &&
      productName.length > 0
    ) {
      productLink.map((item, index) => {
        if (page > 1) {
          if (
            productLink[item].attribs.class === "a-link-normal s-no-outline"
          ) {
            if (
              !productLink[item].attribs.href.includes("/s?") &&
              !productLink[item].attribs.href.includes("/gp/")
            ) {
              productLinkArrayConst.push(
                productLink[item].attribs.href.substr(
                  0,
                  productLink[item].attribs.href.length - 16
                )
              );
              productImageLinkConst.push(
                productLink[item].children[0].children[0].attribs.src
              );
            }
          }
        } else {
          if (
            productLink[item].attribs.class === "a-link-normal s-no-outline"
          ) {
            if (
              !productLink[item].attribs.href.includes("/s?") &&
              !productLink[item].attribs.href.includes("/gp/")
            ) {
              productLinkArrayConst.push(productLink[item].attribs.href);
              if (productLink[item].children[0].children[0] !== undefined) {
                productImageLinkConst.push(
                  productLink[item].children[0].children[0].attribs.src
                );
              }
            }
          }
        }
      });
      todayPrice.map((item, index) => {
        if (todayPrice[item].attribs.class === "a-price") {
          //today price
          todayPriceConst.push(todayPrice[item].children[0].children[0].data);
        } else if (todayPrice[item].attribs.class === "a-price a-text-price") {
          originalPriceConst.push(
            todayPrice[item].children[0].children[0].data
          );
        }
      });
      const removeDuplicateProductLink = [...new Set(productLinkArrayConst)];
      const finalData = removeDuplicateProductLink.map((item, index) => {
        return {
          id: index,
          affliateUrl: "https://www.amazon.in" + item + "&tag=aman0809-21",
          originalUrl: "https://www.amazon.in" + item,
          originalPrice: originalPriceConst[index],
          todayPrice: todayPriceConst[index],
          productImageLink: productImageLinkConst[index],
          productName: productName[index],
        };
      });
      setFinalData(finalData);
    }
  }
  function printAns() {
    if (finalData.length > 0) {
      return finalData.map((item, index) => {
        return (
          <div key={index} className="col-md-4 col-sm-12 mb-4">
            <div className="card">
              <img
                src={item.productImageLink}
                className="card-img-top img-fluid"
                alt={item.productImageLink}
              />
              <div className="card-body">
                <h4 className="card-title">{item.productName}</h4>
                <h5 className="card-text bg-warning">
                  Price: {item.todayPrice}
                  <span
                    style={{
                      textDecoration: "line-through",
                      paddingLeft: "1rem",
                    }}
                  >
                    {item.originalPrice}
                  </span>
                </h5>
                <a
                  href={item.affliateUrl}
                  target="_blank"
                  className="btn btn-primary"
                  style={{ width: "100%" }}
                >
                  Go to Page
                </a>
              </div>
            </div>
          </div>
        );
      });
    } else {
      return <h3>Loading...</h3>;
    }
  }

  function onClickHandler(e) {
    const { name } = e.target;
    if (name === "next") {
      const temp = page;
      setFinalData([]);
      setPage(temp + 1);
    } else {
      if (page > 1) {
        const temp = page;
        setFinalData([]);
        setPage(temp - 1);
      } else {
        alert("You are on the first page");
      }
    }
  }

  return (
    <div className="container-fluid">
      {!error ? (
        <>
          <div className="alert alert-primary" role="alert">
            <h3 className="text-center">
              Your Daily Dose of{" "}
              <span style={{ textDecoration: "underline" }}>Amazon</span> Deals
            </h3>
          </div>
          <div className="row">{printAns()}</div>
          <div className="navigation-button d-flex justify-content-between">
            <div>
              <button
                onClick={onClickHandler}
                name="previous"
                className="btn btn-outline-primary"
              >
                Previous
              </button>
            </div>
            <div className="justify-content-center">{page}</div>
            <div>
              <button
                onClick={onClickHandler}
                name="next"
                className="btn btn-outline-primary"
              >
                Next
              </button>
            </div>
          </div>
        </>
      ) : (
        <div>
          <h3>Something went wrong. Reload the page or try again later.</h3>
          <div className="reload-button">
            <button
              onClick={() => window.location.reload()}
              type="button"
              className="btn btn-info"
            >
              Reload
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
